<template>
  <path
    d="M4 18V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18Z"
    fill="#EF501E"
  />
  <path
    d="M7.03022 13.2383V15H6V10H7.95055C8.32601 10 8.65568 10.0687 8.93956 10.206C9.22573 10.3434 9.44551 10.5391 9.5989 10.7933C9.75229 11.0451 9.82898 11.3324 9.82898 11.6552C9.82898 12.1451 9.66071 12.5321 9.32418 12.8159C8.98993 13.0975 8.52633 13.2383 7.93338 13.2383H7.03022ZM7.03022 12.4038H7.95055C8.22299 12.4038 8.43017 12.3397 8.57212 12.2115C8.71635 12.0833 8.78846 11.9002 8.78846 11.6621C8.78846 11.4171 8.71635 11.2191 8.57212 11.068C8.42788 10.9169 8.22871 10.8391 7.97459 10.8345H7.03022V12.4038Z"
    fill="white"
  />
  <path
    d="M10.5398 15V10H12.0783C12.5179 10 12.9105 10.0996 13.2562 10.2988C13.6042 10.4957 13.8755 10.7772 14.0701 11.1435C14.2647 11.5076 14.362 11.9219 14.362 12.3867V12.6168C14.362 13.0815 14.2658 13.4947 14.0735 13.8565C13.8835 14.2182 13.6145 14.4986 13.2665 14.6978C12.9185 14.897 12.5259 14.9977 12.0886 15H10.5398ZM11.5701 10.8345V14.1724H12.068C12.4709 14.1724 12.7788 14.0408 12.9918 13.7775C13.2047 13.5142 13.3134 13.1376 13.318 12.6477V12.3832C13.318 11.875 13.2127 11.4904 13.0021 11.2294C12.7914 10.9661 12.4835 10.8345 12.0783 10.8345H11.5701Z"
    fill="white"
  />
  <path
    d="M18.1223 12.9567H16.1442V15H15.114V10H18.3695V10.8345H16.1442V12.1257H18.1223V12.9567Z"
    fill="white"
  />
</template>
